import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AppCoreService } from 'src/app/services/app-core.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-event-config',
  templateUrl: './event-config.component.html',
  styleUrls: ['./event-config.component.scss'],
})
export class NotificationEventConfigComponent implements OnInit {
  notificationForm: FormGroup;
  @Input() eventData: any;
  @Input() customerEventConfig: any;
  @ViewChild('content') content: ElementRef;
  isExpanded = false;

  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };

  accordionItems = [];
  useEnterKey: any;

  constructor(
    private formBuilder: FormBuilder,
    public router: Router,
    public activeModal: NgbActiveModal,
    private appCoreService:AppCoreService,
  ) { }

  ngOnInit() {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;

    this.notificationForm = this.formBuilder.group({});
    this.eventData = this.eventData.map(item => ({
      ...item,
      key: item.name.replace(/ /g, '_')
    }));
    this.customerEventConfig = this.customerEventConfig.map(item => ({
      ...item,
      key: item.name.replace(/ /g, '_')
    }));
    this.accordionItems = this.eventData;
    // Dynamically create form controls for each accordion item
    this.accordionItems.forEach(item => {
      const idControlName = 'id' + item.key;
      const emailControlName = 'email' + item.key;
      const smsControlName = 'sms' + item.key;
      const whatsappControlName = 'whatsapp' + item.key;

      this.notificationForm.addControl(idControlName, new FormControl(item.id));
      this.notificationForm.addControl(emailControlName, new FormControl({ value: false, disabled: item.isemaildisable }));
      this.notificationForm.addControl(smsControlName, new FormControl({ value: false, disabled: item.issmsdisable }));
      this.notificationForm.addControl(whatsappControlName, new FormControl({ value: false, disabled: item.iswhatsappdisable }));

    });
    this.customerEventConfig.length? this.bindCustomerConfig(): null;
  }

  bindCustomerConfig() {
    this.customerEventConfig.forEach(config => {
      const idControlName = 'id' + config.key;
      const key = config.key;
      const emailControlName = 'email' + key;
      const smsControlName = 'sms' + key;
      const whatsappControlName = 'whatsapp' + key;

      this.notificationForm.patchValue({
        [idControlName]: config.id,
        [emailControlName]: config.isemail,
        [smsControlName]: config.issms,
        [whatsappControlName]: config.iswhatsapp
      });
    });
  }


  createDatabaseArray() {
    const formValues = this.notificationForm.value;
    const uniqueKeys = {};
    const databaseArray = Object.keys(formValues).map(x => {
        const type = x.replace(/^(email|sms|whatsapp)/, '');
        const id = formValues[`id${type}`];
        if (id) {
            // Check if the key already exists in uniqueKeys
            if (!uniqueKeys[type]) {
                uniqueKeys[type] = true;

                const isEmail = formValues[`email${type}`] || false;
                const isSMS = formValues[`sms${type}`] || false;
                const isWhatsapp = formValues[`whatsapp${type}`] || false;

                return {
                    id: id,
                    name: type,
                    isemail: isEmail,
                    issms: isSMS,
                    iswhatsapp: isWhatsapp
                };
            }
        }
        return null; // Skip creating the object if key already exists or id does not exist
    }).filter(obj => obj !== null); // Filter out null objects
    // console.log('databaseArray', databaseArray);
    return databaseArray;
}


  onSaveClick() {
    const databaseEventObj = this.createDatabaseArray();
    this.activeModal.close(databaseEventObj);
  }

  toggleAll() {
    this.isExpanded = !this.isExpanded;
  }

}
